/* DORI: Shop the look drawer for collection Featured image blocks */
(function () {
  if (window.__doriLook) return;
  window.__doriLook = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function openDrawer(d) {
    if (d.parentNode !== document.body) document.body.appendChild(d);
    d.hidden = false;
    d.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    document.documentElement.classList.add('dori-look-lock');
    var c = d.querySelector('.dori-look__close');
    if (c) c.focus({ preventScroll: true });
  }

  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dori-look-lock');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 350);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
      el.classList.toggle('hidden', count < 1);
    });
  }

  function addToBag(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        showToast(btn, 'Added to cart');
        updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        showToast(btn, (err && err.description) || 'Could not add to cart');
      });
  }

  function showToast(btn, msg) {
    var drawer = btn.closest('.dori-look');
    var toast = drawer && drawer.querySelector('.dori-look__toast');
    if (!toast) return;
    var text = toast.querySelector('[data-dori-look-toast-text]');
    if (text) text.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-dori-look-open]');
    if (o) {
      var d = document.getElementById(o.getAttribute('data-dori-look-open'));
      if (d) { e.preventDefault(); openDrawer(d); }
      return;
    }
    var c = e.target.closest('[data-dori-look-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.dori-look')); return; }
    var a = e.target.closest('[data-dori-look-add]');
    if (a) { e.preventDefault(); addToBag(a); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer(document.querySelector('.dori-look.is-open'));
  });
})();
